import {
    registerDecorator,
    ValidationOptions,
    ValidationArguments,
} from 'class-validator';

// Custom Validator: Checks if `status` is `done` and `file` is not empty
export function IsFileValid(validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: 'isFileValid',
            target: object.constructor,
            propertyName: propertyName,
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    return (
                        value &&
                        typeof value === 'object' &&
                        value.status === 'done'
                    );
                },
                defaultMessage(args: ValidationArguments) {
                    return `The file must be uploaded and its status should be 'done'.`;
                },
            },
        });
    };
}
